import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ThemeProvider } from "react-bootstrap";

/* STYLES */
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/global.scss";

/* LAYOUT IMPORTS */
import Layout from "../layout/index";

/* PAGES IMPORT */
import Home from "../pages/index";
import BuyerOverview from "../pages/buying";
import SellerOverview from "../pages/selling";
import ContactMe from "../pages/contact-me";
import Blogs from "../pages/blogs/index";
import BlogDetail from "../pages/blogs/blog-detail";
import ActiveListings from "../pages/active-listings";
import PropertyDetails from "../pages/active-listings/detail-view";
import FeaturedListings from "../pages/active-listings/featured-listing";
import HomeEvaluation from "../pages/home-evaluation/index";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const WebsiteRoutes = () => {
  return (
    <ThemeProvider breakpoints={["xl", "lg", "md", "sm"]} minBreakpoint="sm">
      <div className="app">
        <Router>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/buying" element={<BuyerOverview />} />
              <Route path="/selling" element={<SellerOverview />} />
              <Route path="/contact-me" element={<ContactMe />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blog-detail/:id" element={<BlogDetail />} />
              <Route path="/active-listings" element={<ActiveListings />} />
              <Route path="/property-detail/:mlsId/:mlsKey" element={<PropertyDetails />} />
              <Route path="/featured-listings" element={<FeaturedListings />} />
              <Route path="/home-evaluation" element={<HomeEvaluation />} />
            </Routes>
          </Layout>
        </Router>
      </div>
    </ThemeProvider>
  );
};

export default WebsiteRoutes;
